// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PersonalConversation_header__yaxkW {
    margin-bottom: 25px;
}

.PersonalConversation_title__mO6Cp {
    font-size: 30px;
}

.PersonalConversation_user__m3DCm {
    font-size: 20px;
    margin-top: 25px;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/PersonalConversation/index.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".header {\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.user {\n    font-size: 20px;\n    margin-top: 25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `PersonalConversation_header__yaxkW`,
	"title": `PersonalConversation_title__mO6Cp`,
	"user": `PersonalConversation_user__m3DCm`
};
export default ___CSS_LOADER_EXPORT___;
